export const SECTION_TOP_DIVIDER =
  "before:absolute before:top-0 before:left-0 before:right-0 before:h-px before:bg-[linear-gradient(to_right,transparent,rgba(var(--ip-primary-glow),0.3),transparent)] before:content-['']";
